// extracted by mini-css-extract-plugin
export default {"site_header":"Header_site_header__ZOgM8"};